const stack = [];
export function instantiateModalStack() {
  let initialIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  let index = -1;
  const pull = () => {
    if (index > -1) {
      const found = stack.indexOf(index);
      // Assert: found should always be greater than -1
      // istanbul ignore else
      if (found > -1) {
        stack.splice(found, 1);
      }
    }
  };
  const push = () => {
    var _stack;
    // Handle pushes without pull
    pull();
    // Find the next available index
    index = ((_stack = stack[stack.length - 1]) !== null && _stack !== void 0 ? _stack : -1) + 1;
    stack.push(index);
    return index + initialIndex;
  };
  return {
    push,
    pull
  };
}
//# sourceMappingURL=ModalStack.js.map